define('helperContent',['require','helperContent-cloneEntity','helperContent-cloneInitEntity','helperContent-getEntity','helperContent-getTaskEntities','helperContent-getQuizGame','helperContent-getQuizGameMap','helperContent-getQuizMap','helperContent-getTrainingMapping','helperContent-getLastQuiz','helperContent-convertComponents','helperContent-getSectionEntities','helperContent-componentObject','helperContent-customText'],function(require) {
    'use strict';

    var Content = {
        cloneEntity: require('helperContent-cloneEntity'),
        cloneInitEntity: require('helperContent-cloneInitEntity'),
        getEntity: require('helperContent-getEntity'),
        getTaskEntities: require('helperContent-getTaskEntities'),
        getQuizGame: require('helperContent-getQuizGame'),
        getQuizGameMap: require('helperContent-getQuizGameMap'),
        getQuizMap: require('helperContent-getQuizMap'),
        getTrainingMap: require('helperContent-getTrainingMapping'),
        getLastQuiz: require('helperContent-getLastQuiz'),
        convertComponents: require('helperContent-convertComponents'),
        getSectionEntities: require('helperContent-getSectionEntities'),
        componentObject: require('helperContent-componentObject'),
        customText: require('helperContent-customText')
    };

    return Content;

});
